import { Component, inject, OnInit } from '@angular/core';
import Keycloak from 'keycloak-js';
import { NavigationService, NavigationItem, Role, ResponsiveBaseComponent } from 'shared-lib';
import { VerticalNavComponent } from 'shared-lib';
import { RoleService } from '../auth/role-service';
import { loginOptions } from '../auth/login-options';
import { JkuUserService } from '../jku-webshop/jku-user.service';
import { VerticalMenuMobileNavComponent } from '../../../../shared-lib/src/lib/components/vertical-menu-mobile-nav/vertical-menu-mobile-nav.component';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [VerticalMenuMobileNavComponent, VerticalNavComponent],
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent extends ResponsiveBaseComponent implements OnInit {
  private readonly roleService = inject(RoleService);
  private readonly keycloak = inject(Keycloak);
  private readonly jkuUser = inject(JkuUserService);
  private navigationService = inject(NavigationService);
  protected navigationItems: NavigationItem[] = [];

  private async initializeNavigation(): Promise<void> {
    const homeNavItem: NavigationItem = {
      id: 'home',
      label: 'Home',
      icon: 'home',
      route: '/'
    };

    // JKU SSO users get a shortcut to the JKU webshop; hidden for everyone else.
    const jkuNavItems: NavigationItem[] = [];
    if (this.jkuUser.isJkuSso()) {
      jkuNavItems.push({
        id: 'jku-webshop',
        label: 'JKU Webshop',
        icon: 'storefront',
        route: '/JKU-webshop'
      });
    }

    const registeredParkerNavItems: NavigationItem[] = [];
    const isParker = await this.roleService.checkAccess(Role.RegisteredParker);
    if (isParker) {
      registeredParkerNavItems.push({
        id: 'activity',
        label: 'Parking Activity',
        icon: 'receipt_long',
        route: '/activity'
      });
      registeredParkerNavItems.push({
        id: 'license-plates',
        label: 'My Vehicles',
        icon: 'directions_car',
        route: '/license-plates'
      });
      registeredParkerNavItems.push({
        id: 'entitlements',
        label: 'Permissions',
        icon: 'vpn_key',
        route: '/entitlements'
      });
    }

    const authenticatedMemberNavItems: NavigationItem[] = [];
    const publicNavItems: NavigationItem[] = [];
    const isAuthenticated = this.roleService.isAuthenticated();

    if (isAuthenticated) {
      authenticatedMemberNavItems.push({
        id: 'my-account',
        label: 'My Account',
        icon: 'account_circle',
        route: '/my-account'
      });
      authenticatedMemberNavItems.push({
        id: 'logout',
        label: 'Logout',
        icon: 'logout',
        action: () => {
          this.keycloak.logout();
        }
      });
    } else {
      publicNavItems.push({
        id: 'login',
        label: 'Login',
        icon: 'login',
        action: () => {
          this.keycloak.login(loginOptions());
        }
      });
      publicNavItems.push({
        id: 'register',
        label: 'Register',
        icon: 'how_to_reg',
        route: '/register'
      });
    }

    this.navigationItems = [
      homeNavItem,
      ...jkuNavItems,
      ...registeredParkerNavItems,
      ...authenticatedMemberNavItems,
      ...publicNavItems
    ];

    this.navigationService.setNavigationItems(this.navigationItems);
  }

  ngOnInit(): void {
    this.initializeNavigation();
  }
}
